// Shared content/data for Home sections. Edit copy/imagery here instead of touching JSX.
import { Award, Headphones, Globe2 } from "lucide-react";

export const BANNER_IMAGE = "/images/hero-banner.webp";

export const STOREFRONT_IMAGE = "/images/storefront.webp";

export const APPOINTMENT_TEXT =
  "Hello Style India Team,\n\n" +
  "I would like to schedule a video call to explore your wholesale collection.\n\n" +
  "Kindly find my details below:\n\n" +
  "• Business / Store Name:\n" +
  "• City & Country:\n" +
  "• Preferred Date & Time for Video Call:\n\n" +
  "Looking forward to connecting with your team.\n\n" +
  "Thank you.";

export const CATALOGUE_TEXT =
  "Hi Style India Delhi — please share your full wholesale catalogue and current rates.";

export const CALL_TEXT =
  "Hi Style India Delhi — I'd like to speak with your wholesale team about an order.";

export const badges = [
  { icon: Award,      title: "Premium Quality",       body: "Hand-picked fabrics, in-house quality checks on every piece before it ships." },
  { icon: Headphones, title: "24×7 Customer Support", body: "Our wholesale desk is reachable any time — order updates, design queries, dispatch help." },
  { icon: Globe2,     title: "Worldwide Shipping",    body: "Seamless exports to 40+ countries worldwide." },
];

export const heroStats = [
  { num: 18,     suffix: "+", v: "Years Experience" },
  { num: 20000,  suffix: "+", v: "Retailers Served" },
  { text: "M & W",            v: "Manufacturer & Wholesaler" },
];

export const MARQUEE_TAGS = [
  "Designer Suits",
  "Festive & Bridal",
  "Kurta Sets",
  "Indo-Western",
  "Kaftans",
  "Co-Ord Sets",
  "Since 2007",
  "Lajpat Nagar · New Delhi",
  "Worldwide Shipping",
  "Wholesale Only",
];

export const stores = [
  { tag: "Shop 01", label: "Style India D43", lat: 28.564278, lng: 77.244250, addr: "D-43, Old Double Storey, Lajpat Nagar IV, New Delhi 110024", mapQ: "28.564278,77.244250" },
  { tag: "Shop 02", label: "Style India D29", lat: 28.563972, lng: 77.244722, addr: "D-29, Old Double Storey, Lajpat Nagar IV, New Delhi 110024", mapQ: "28.563972,77.244722" },
];

export const COLLECTION_TILES = [
  {
    name: "Midnight Bloom Phiran",
    category: "Designer Phiran",
    image_url: "/images/tile-1-phiran.webp",
  },
  {
    name: "Lime Luxe Cape Set",
    category: "Indo-Western Cape",
    image_url: "/images/tile-2-cape.webp",
  },
  {
    name: "Olive Garden Suit Set",
    category: "Kurta Set",
    image_url: "/images/tile-3-olive.jpg",
  },
  {
    name: "Scarlet Poppy Ensemble",
    category: "Festive Print Suit",
    image_url: "/images/tile-4-scarlet.jpg",
  },
  {
    name: "Blush Blossom Co-ord Set",
    category: "Co-Ord Set",
    image_url: "/images/tile-5-blush.jpg",
  },
  {
    name: "Ruby Radiance Suit Set",
    category: "Festive Suit Set",
    image_url: "/images/tile-6-ruby.jpg",
  },
];
